// TODO: Perhaps, this should be a more generic component.
// !!! So it really seems!

// TODO: It needs further improvements (read the comments at the place where
// this component is used).

import {
  type FunctionComponent,
  type ReactNode,
  useEffect,
  useEffectEvent,
  useRef,
  useState,
} from 'react';

import Player, { type VimeoEmbedParameters } from '@vimeo/player';

import { isVimeoUrl } from 'utils';

import './style.scss';

type PropsT = {
  aspectRatio?: number;
  autoplay?: boolean;
  hideControls?: boolean;
  loop?: boolean;

  /** Called if the player fails to load the video (e.g. it was deleted
   *  directly on Vimeo, and this URL no longer resolves to anything). */
  onError?: () => void;

  placeholder: ReactNode;
  url: string;
};

const VimeoVideoPreview: FunctionComponent<PropsT> = ({
  aspectRatio,
  autoplay,
  hideControls,
  loop,
  onError,
  placeholder,
  url,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [ready, setReady] = useState(false);

  const onErrorEvent = useEffectEvent(() => {
    onError?.();
  });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) throw Error('Internal error');

    if (!isVimeoUrl(url)) throw Error('Not a Vimeo URL');

    const params: VimeoEmbedParameters = {
      controls: !hideControls,
      url,
    };

    // NOTE: Because there is a bug in @vimeo/player, I believe:
    // even when `autoplay`/`loop` are "undefined", if such fields with
    // undefined value are added to params they are serialized as the
    // literal string "undefined" in the oembed query, which Vimeo's API
    // rejects with a 400. Rather than pointing out to Vimeo team their
    // incompetence and doing their work for them... let's just quitely
    // workaround it this way, for now.
    if (autoplay) params.autoplay = true;
    if (loop) params.loop = true;

    const player = new Player(container, params);

    void player.ready().then(() => {
      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.style.height = '100%';
        iframe.style.width = '100%';
      }
      setReady(true);
    }).catch(onErrorEvent);

    return () => {
      void player.destroy();
      setReady(false);
    };
  }, [autoplay, hideControls, loop, url]);

  return (
    <div styleName="container">
      {placeholder}
      <div
        ref={containerRef}
        style={{
          aspectRatio,
          display: ready ? 'block' : 'none',
          height: '100%',
          position: 'absolute',
          top: 0,
          width: '100%',
        }}
      />
    </div>
  );
};

export default VimeoVideoPreview;
